import React, { useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import CheckIcon from '@material-ui/icons/Check';
import { makeStyles, SvgIcon } from "@material-ui/core";
import phoneCall from '../../../../icons/phoneCall.svg';
import InsurancePlanFooter from '../../Common/InsurancePlanFooter/InsurancePlanFooter';
import PropTypes from 'prop-types';
import { 
    SESSION_STORAGE_FINAL_EXPENSE_HEALTH_KEY,
    SESSION_STORAGE_FINAL_EXPENSE_TERM_KEY, 
    SESSION_STORAGE_UNIVERSAL_LIFE_HEALTH_KEY, 
    SESSION_STORAGE_UNIVERSAL_LIFE_TERM_KEY,
    SESSION_STORAGE_WHOLE_LIFE_HEALTH_KEY,
    SESSION_STORAGE_WHOLE_LIFE_TERM_KEY,
    SESSION_STORAGE_BUSINESS_SOLUTIONS_KEY,

} from '../../../../sessionStorage';
import CustomerSupportPhone from "../../../Account/CustomerSupportPhone";
import { parse, format } from 'date-fns';
import { CustomNextSteps } from '../../../Quoters/Common/Appointment/CustomNextSteps';
import '../../../Quoters/Common/ScheduleAppointment.scss';
import './ScheduleAppointment.scss';

const useStyles = makeStyles(theme => ({
    colorText: {
        color: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },
    lightBackground: {
        backgroundColor: `${theme.palette.primary.main}16`,
    },
}));

export default function ScheduleAppointment(props) {
    const classes = useStyles();

    useEffect(() => {
        if (props.isFinalExpense) {
            sessionStorage.removeItem(SESSION_STORAGE_FINAL_EXPENSE_HEALTH_KEY);
            sessionStorage.removeItem(SESSION_STORAGE_FINAL_EXPENSE_TERM_KEY);
        }
        if (props.isWholeLife) {
            sessionStorage.removeItem(SESSION_STORAGE_WHOLE_LIFE_HEALTH_KEY);
            sessionStorage.removeItem(SESSION_STORAGE_WHOLE_LIFE_TERM_KEY);
        }
        if (props.isUniversalLife){
            sessionStorage.removeItem(SESSION_STORAGE_UNIVERSAL_LIFE_HEALTH_KEY);
            sessionStorage.removeItem(SESSION_STORAGE_UNIVERSAL_LIFE_TERM_KEY);
        }
        if (props.isBusinessSolutions){
            sessionStorage.removeItem(SESSION_STORAGE_BUSINESS_SOLUTIONS_KEY);
        }
    }, []);

    const customerSupportPhone = CustomerSupportPhone();
    const appointment = props.appointment;

    let contactDatetime = 'within one business day';

    if (appointment.specificAppt === 'schedule') {
        if (appointment.specificApptTime && appointment.specificApptDate && appointment.timeZone) {
            const contactDate = parse(appointment.specificApptDate, 'MM-dd-yyyy', new Date());
            contactDatetime = `${format(contactDate, 'EEEE, MMMM d')} ${appointment.specificApptTime} ${appointment.timeZone}`;
        } else {
            contactDatetime = 'at your specified date and time';
        }
    }

    return (
        <React.Fragment>
            <Container className='custom-appointment-info pt-4'>
                <Row>
                    <Col md={6} className="review-container d-flex align-items-center">
                        <CustomNextSteps title={props.title} data={props.data} />
                    </Col>
                    <Col md={6} lg={4} className="mx-auto">
                        <React.Fragment>
                            <div className='fixed-schedule text-center'>
                                <Row className="justify-content-center">

                                    <div className={`icon-container ${classes.lightBackground}`}>
                                        <SvgIcon component={CheckIcon} color='primary' />
                                    </div>
                                </Row>
                                <div className="schedule-title mb-1 mt-2">
                                    <h4>Congrats - your call has been scheduled</h4>
                                </div>
                                <div className='content-title'>
                                    <div className='schedule-content' ><b>We will contact you {appointment.specificAppt === 'schedule' ? 'on ' : '' }<span
                                        className={classes.colorText}>{contactDatetime}</span> within a 30 minute timeframe of your appointment</b></div>
                                </div>
                                <div className='text-center team-content'>
                                    {props.isBusinessSolutions ? "We look forward to helping you secure the protection you need!" : "We look forward to speaking with you!"}
                                </div>
                                <div className='mt-4'><b>Want to talk to someone today?</b></div>
                                <Row className='mt-2 d-flex justify-content-center'>
                                    <SvgIcon component={phoneCall} color="primary" className='mr-1' /><b>
                                    <a href={`tel:${customerSupportPhone}`} className={`${classes.colorText} ml-1`}>{customerSupportPhone}</a></b>
                                </Row>
                            </div>
                            <div />
                        </React.Fragment>
                    </Col>
                </Row>
            </Container>
            <InsurancePlanFooter InsurancePlan={props.insurancePlan} props={props} classes={classes} />
        </React.Fragment>
    );
}

ScheduleAppointment.propTypes = {
    isBusinessSolutions: PropTypes.bool,
    appointment: PropTypes.object,
    title: PropTypes.string,
    data: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Appointment/ScheduleAppointment.js